module.exports = __webpack_public_path__ + "static/media/hostastay-logo-with-white-background.fcb43532.png";